<div *ngIf="checkinMode; else legacyPhoneVerification" class="checkin-phone" [dir]="globalService.isRTL ? 'rtl' : 'ltr'">
  <ng-container *ngIf="sendStatus === 0">
    <label for="checkin-phone-number">{{ ('MOBILE_NUMBER' | translate) }}</label>
    <div class="checkin-phone-fields" dir="ltr"><select [attr.aria-label]="'DIALING_CODE' | translate" [ngModel]="countryCode" (ngModelChange)="changeDialCode($event)" [disabled]="sendingCode || verifyingCode"><option *ngFor="let country of phoneCountries" [value]="country.code">{{ country.name }} ({{ country.dial_code }})</option></select><input id="checkin-phone-number" type="tel" inputmode="tel" autocomplete="tel-national" [(ngModel)]="phone_number" (input)="phoneNumberChange($event)" (keydown.enter)="$event.preventDefault(); SendCode()" [readonly]="sendingCode" /></div>
    <app-user-message *ngIf="errorMessage" type="error" [message]="errorMessage" [dismissible]="false"></app-user-message>
    <button type="button" class="btn btn-primary btn-block" (click)="SendCode()" [disabled]="sendingCode" [attr.aria-busy]="sendingCode">{{ sendingCode ? ('SENDING_CODE' | translate) : ('SEND_VERIFICATION_CODE' | translate) }}</button>
  </ng-container>
  <ng-container *ngIf="sendStatus === 1">
    <h3>{{ ('ENTER_YOUR_CODE' | translate) }}</h3><p>{{ ('WE_SENT_A_FOUR_DIGIT_CODE_TO' | translate) }} <strong dir="ltr">{{ maskedNumber }}</strong>.</p>
    <button type="button" class="checkin-phone-link" (click)="Clear()" [disabled]="sendingCode || verifyingCode">{{ ('CHANGE_NUMBER' | translate) }}</button>
    <label for="checkin-verification-code">{{ ('VERIFICATION_CODE' | translate) }}</label><input id="checkin-verification-code" class="checkin-phone-code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="4" [(ngModel)]="verificationCode" (input)="errorMessage = ''" (keydown.enter)="$event.preventDefault(); VerifyCode()" [readonly]="verifyingCode || sendingCode" dir="ltr" />
    <app-user-message *ngIf="errorMessage" type="error" [message]="errorMessage" [dismissible]="false"></app-user-message><p *ngIf="sentAgain && !errorMessage" role="status">{{ ('A_NEW_CODE_HAS_BEEN_SENT' | translate) }}</p>
    <button type="button" class="btn btn-primary btn-block" (click)="VerifyCode()" [disabled]="verifyingCode || sendingCode" [attr.aria-busy]="verifyingCode">{{ verifyingCode ? ('VERIFYING' | translate) : ('VERIFY_CONTINUE' | translate) }}</button>
    <button type="button" class="checkin-phone-link" (click)="SendCode()" [disabled]="resendSeconds > 0 || sendingCode || verifyingCode">{{ resendSeconds > 0 ? ('RESEND_CODE_COUNTDOWN' | translate:{seconds: resendSeconds}) : ('RESEND_CODE' | translate) }}</button>
  </ng-container>
</div>
<ng-template #legacyPhoneVerification><div class="form-group ">
    <div class="row">
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus != 3">
            <label for="phone_number">{{
                globalService.Get("CELLPHONE")
                }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
            <div class="input-group" dir="ltr">
                <div class="input-group-prepend">
                    <div class="input-group-text">{{ dial_code }}</div>
                </div>
                <input type="text" OnlyNumber="true" [readonly]="sendStatus > 0 || sendingCode || verifyingCode" [disabled]="enabled == false" id="phone_number"
                    [(ngModel)]="phone_number" (input)="phoneNumberChange($event)" class="form-control" [class.unconfirmedPhone]="phoneConfirmed == false"
                    autocomplete="off" />
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'"
            *ngIf="sendStatus == 0 && phone_number != null && phone_number.length > 9" class="mt-4">
            <div *ngIf="errorMessage == ''">
                <label class="mr-sm-3 mr-1">{{
                    globalService.Get("VERIFY_PHONE")

                    }}</label>
                <button type="button" class="btn btn-small btn-secondary" (click)="SendCode()" [disabled]="sendingCode || verifyingCode" [attr.aria-busy]="sendingCode"><i *ngIf="sendingCode" class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>{{ globalService.Get('SEND_CODE') }}</button>
            </div>
            <div *ngIf="errorMessage != ''">
                <app-prompt-message [showForm]="errorMessage != ''" color="primary" (onClose)="Retry()"
                    [message]="errorMessage">
                </app-prompt-message>
                <div class="row">
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-primary" (click)="Retry()" value="Try Again"
                            >
                    </div>
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-success"  (click)="Signup()"
                            value="Create Account">
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 1">
            <p *ngIf="errorMessage" class="text-danger" role="alert">{{ errorMessage }}</p>
            <label class="mt-3 mr-sm-3 mr-1">{{
                globalService.Get("ENTER_4DIGIT")
                }}</label>
            <div class="row">
                <div class="col-6">
                    <input type="text" OnlyNumber="true" id="verificationCode" maxlength="4"
                        [(ngModel)]="verificationCode" class="form-control" autocomplete="off">
                </div>
                <div class="col-6">
                    <button type="button" class="btn btn-small btn-secondary" (click)="VerifyCode()" [disabled]="verifyingCode || sendingCode" [attr.aria-busy]="verifyingCode"><i *ngIf="verifyingCode" class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>{{ globalService.Get('VERIFY') }}</button>
                </div>
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 2">
            <label class="mr-sm-3 mr-1">{{
                globalService.Get("CLICK_TO_CHANGE")
                }}</label>

            <div>
                <input type="button" class="btn btn-small btn-secondary" (click)="Clear()"
                    [value]="globalService.Get('CLEAR')">
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 3">
            <span>{{ 'FAILED_TO_VERIFY_818C2AF' | translate }}</span>
        </div>
    </div>
</div></ng-template>
